<div class="filter-wrapper">
  <mat-icon (click)="viewFilter = !viewFilter">filter_alt</mat-icon>
  @if (viewFilter) {
    @for (each of filterItems; track each) {
      <mat-checkbox
        (change)="handleFilter.emit({ event: $event, filterItem: each })"
        [checked]="each.status"
        >{{ each.label }}</mat-checkbox
      >
    }
  }
</div>
